import { getCookie } from "@/lib/get-cookie";

export const EXPERIENCE_TYPE_COOKIE = "checkout_experience_type";
export const EXPERIENCE_TYPE_COOKIE_MAX_AGE = 60 * 60 * 24 * 90;

export type ExperienceType = "campaign" | "product";

export function isExperienceType(value: string): value is ExperienceType {
  return value === "campaign" || value === "product";
}

const buildExperienceTypeCookie = (value: string, maxAge: number) => {
  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:"
      ? "; Secure"
      : "";

  return `${EXPERIENCE_TYPE_COOKIE}=${value}; path=/; max-age=${maxAge}; SameSite=Lax${secure}`;
};

export const persistExperienceType = (experienceType: ExperienceType) => {
  if (typeof document === "undefined") return;

  document.cookie = buildExperienceTypeCookie(
    experienceType,
    EXPERIENCE_TYPE_COOKIE_MAX_AGE,
  );
};

export const readExperienceType = (): ExperienceType | undefined => {
  if (typeof document === "undefined") return undefined;

  const cookieValue = getCookie(EXPERIENCE_TYPE_COOKIE);
  return cookieValue && isExperienceType(cookieValue) ? cookieValue : undefined;
};

export const clearExperienceType = () => {
  if (typeof document === "undefined") return;

  document.cookie = buildExperienceTypeCookie("", 0);
};
